export default {
  getMyAvailabilities: state => state.myAvailabilities,
  getAvailabilities: state => state.availabilities,

  mySchedules: state => state.mySchedules,
}
